import  { useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import DynamicTabsPage from "../tabs/tabs";
import apiHelper from '../../utils/apiHelper';
import { EntityType, UnitService } from '@propertelligent/client-api';
import SimpleSpinner from '../../components/loader';
import UnitCardItem from './UnitCardItem';
import AddUnitForm from './AddUnitForm';

const UnitDetails2 = () => {
  const { id } = useParams();
  const [listingData, setListingData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showConfirmation, setShowConfirmation] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [editUnitData, setEditUnitData] = useState(null); 
  const [paymentRefreshTrigger, setPaymentRefreshTrigger] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();

  // Fetch unit data on component mount
 const fetchUnitDetails = () => {
    if (!id) return;

    setLoading(true);                                     

    apiHelper(UnitService.getApiUnit1, { showNotification: false }, id)
      .then((res) => {
        if (res?.data?.success) {
          setListingData(res.data.success);
          setShowConfirmation(null);
        }
      })
      .catch((err) => {
        console.error("Error fetching unit:", err);
        setShowConfirmation(null);
      })
      .finally(() => {
        setLoading(false);                                
      });
  };

  // Fetch unit data for edit action
  const fetchUnitForEdit = async (unitId) => {
    try {
      const res = await apiHelper(UnitService.getApiUnit1, { showNotification: false }, unitId);
      if (res?.data?.success) {
        setEditUnitData(res.data.success); // Set fetched data for edit
        setModalOpen(true); // Open modal after data is fetched
      }
    } catch (err) {
      console.error("Error fetching unit for edit:", err);
    }
  };

  useEffect(() => {
    fetchUnitDetails();
  }, [id]);

  // Mock fetchData function
  const fetchData = (page) => {
    console.log(`Fetching data for page ${page}`);
  };

  const handlePaymentAdded = () => {
    fetchUnitDetails();
    setPaymentRefreshTrigger(prev => prev + 1); // Signal PaymentList to refresh
  };
  

// Pass state signal when navigating back after delete
const handleDeleteUnit = (unitId) => {
  apiHelper(UnitService.deleteApiUnit, {
    successMessage: "Unit Deleted Successfully",
    showNotification: true
  }, unitId)
    .then((res) => {
      if (res?.data?.success) {
        setShowConfirmation(null);
        const referrer = location.state?.from || '/units';
        navigate(referrer, { state: { refreshUnits: true } }); 
      }
    })
    .catch((err) => {
      console.error("Error deleting unit:", err);
      setShowConfirmation(null);
    });
};

  // Handle edit unit action
  const handleEditUnit = (unit) => {
    fetchUnitForEdit(unit.id); // Fetch latest data from API
  };

  const tabs = [
    "Overview",
    "Service Requests",
    "Payments",
    "Leases",
    "Transactions",
    "Listing Details"
  ];

  if (loading) {
    return (
     <SimpleSpinner myClassName={"Icon50"} isFullPage={true} />
    );
  }

  return (
    <div className='content-wrapper'>
      {listingData ? (
        <>
          <UnitCardItem
            className="property-card-item-single"
            listingData={listingData}
            IsFooter={true}
            showConfirmation={showConfirmation}
            setShowConfirmation={setShowConfirmation}
            handleDeleteUnit={handleDeleteUnit}
            onEditUnit={handleEditUnit}
            onPaymentAdded={handlePaymentAdded}
            isNotLink={true}
          />
          {
            isModalOpen && (
              <AddUnitForm
                isModalOpen={isModalOpen}
                setModalOpen={setModalOpen}
                unitData={editUnitData} // Pass API-fetched data
                fetchUnitDetails={fetchUnitDetails}
                fetchData={fetchData}
              />
            )
          }

        </>
      ) : (
        <></>
      )}
      <DynamicTabsPage tabs={tabs} defaultActiveTab="Overview" entityType={EntityType.Unit} paymentRefreshTrigger={paymentRefreshTrigger} onPaymentAction={handlePaymentAdded} />
    </div>
  );
};

export default UnitDetails2;